// ComoDonar.jsx — sección "Cómo donar", panel de donación + métodos.

import React from 'react'
import { DonationPanel } from '../donation/DonationPanel.jsx'

function BulletPoint({ title, text }) {
  return (
    <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
      <div
        style={{
          width: 22, height: 22, borderRadius: "50%",
          background: "var(--accent-soft)", color: "var(--gold)",
          display: "grid", placeItems: "center",
          flexShrink: 0, marginTop: 2,
        }}
      >
        <svg width="12" height="12" viewBox="0 0 12 12">
          <path d="M 2 6 L 5 9 L 10 3" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div>
        <div style={{ fontWeight: 700, fontSize: 14.5, marginBottom: 4 }}>{title}</div>
        <div style={{ fontSize: 13.5, color: "var(--fg-mute)", lineHeight: 1.55 }}>
          {Array.isArray(text)
            ? text.map((line, i) => <div key={i}>{line}</div>)
            : text}
        </div>
      </div>
    </div>
  );
}

function ComoDonar({ campaign }) {
  return (
    <section id="como" style={{ background: "var(--bg-sunken)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="wrap">
        <div className="section-head fade-up">
          <div className="eyebrow"><span className="dot" />Cómo donar</div>
          <h2 className="h-section" style={{ marginTop: 14 }}>
            Cada aporte <em>cuenta</em>
          </h2>
        </div>

        <div className="hero-grid" style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 48, alignItems: "start" }}>
          <div>
            <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 32 }}>
              <BulletPoint
                title="100% transparente"
                text="Cada peso recaudado se publica en el feed. Los movimientos quedan registrados y auditados por el Cuerpo de Bomberos de Quilpué."
              />
              <BulletPoint
                title="Datos bancarios oficiales"
                text={[
                  "Cuerpo de Bomberos de Quilpué",
                  "Banco de Chile",
                  "Cta. Cte. 1491963010",
                  "RUT 82.104.901-6",
                  "donaciones@bomberosquilpue.cl",
                ]}
              />
              <BulletPoint
                title="Boleta y certificado"
                text="Las empresas reciben certificado tributario previa tramitación. Personas reciben comprobante de aporte a sus correos."
              />
              <BulletPoint
                title="Donación recurrente"
                text="¿Quieres aportar todos los meses? Escríbenos a donaciones@bomberosquilpue.cl y te ayudamos a configurar tu aporte periódico."
              />
            </div>
          </div>

          <div className="sticky-panel">
            <DonationPanel onDonate={campaign.donate} mercadopagoFeeRate={campaign.mercadopagoFeeRate} />
          </div>
        </div>
      </div>
    </section>
  );
}

export { ComoDonar };
